
import IndexModelTable from "@/views/paginas/sigap/modelos/IndexModelTable.vue";
import CardRh from "@/components/cards/ManzaCard.vue";
import { Options } from "vue-class-component";
import SiteUtils from "@/assets/ts/aplicacao/site";
import KDataTable from "@/components/datatable/newdatatable.vue";
import ImpedimentoInstrutorService from "@/service/v1/sigap/ImpedimentoInstrutorService";

@Options({
    name: "ImpedimentoInstrutorIndex",
    components: { CardRh, KDataTable },
})
export default class ImpedimentoInstrutorIndex extends IndexModelTable {
    public service = new ImpedimentoInstrutorService();
    public dataSearch = "";
    public dataMin = "";
    public dataMax = "";
    public search = "";

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === "Enter" || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    public limparFiltros() {
        this.search = "";
        this.dataSearch = "";
        this.dataMin = "";
        this.dataMax = "";
        this.refreshTable();
    }

    created() {
        this.config.order = [[2, "desc"],[3, "desc"]];
        this.config.ajax = {
            url: this.service.getApiUrl(),
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    Data: this.dataSearch,
                    DataMin: this.dataMin,
                    DataMax: this.dataMax,
                    search: this.search || d.search.value,
                };
                return dados;
            }
        };
        this.config.columns = [
            { data: "id", name: "id" },
            { data: "professor.nome", name: "professor" },
            { data: "data", name: "data" },
            { data: "inicio", name: "inicio" },
            { data: "fim", name: "fim" },
            { data: "createdAt", name: "createdAt" },
            { data: "updatedAt", name: "updatedAt" },
        ];
        this.config.columnDefs = [
            {
                targets: 2,
                render: function (row) {
                    return SiteUtils.formatData(row);
                }
            },
            {
                targets: 3,
                render: function (row) {
                    return row ? row.substring(0, 5) : null;
                }
            },
            {
                targets: 4,
                render: function (row) {
                    return row ? row.substring(0, 5) : null;
                }
            },
            {
                targets: 5,
                render: function (row) {
                    return SiteUtils.formatDataHora(row);
                }
            },
            {
                targets: 6,
                render: function (row) {
                    return SiteUtils.formatDataHora(row);
                }
            },
        ];
    }
}
